/* eslint-disable @ngrx/avoid-combining-selectors */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppState } from 'src/app/@store/reducers';
import { StsSelectors } from 'src/app/@store/selectors/sts.selectors';
import { LocalStorageKeys } from 'src/app/models/storage.model';
import { PATIENT_WEB_LOCALE_STORAGE_KEY } from 'src/app/plasma-ui-common/synlab-access-ui-components/core/constants';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { deleteScopeKey, generalScopeKey } from 'src/app/services/i18n/i18n.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent implements OnInit {
  regId = '';
  seqId = '';
  public isValidDeleteAccountLink$: Observable<boolean>;
  isDxp$ = combineLatest([
    this.store.select(StsSelectors.isUkShfyInstance),
    this.store.select(StsSelectors.isITTenant),
    this.store.select(StsSelectors.isGlobalTenant),
  ]).pipe(map(([isShfy, isIT, isGlobal]) => isShfy || isIT || isGlobal));
  useNewNav$: Observable<boolean> = this.store.pipe(select(StsSelectors.useNewNav));

  constructor(
    private readonly actRoute: ActivatedRoute,
    private readonly accountService: AccountsService,
    private readonly toastr: ToastrService,
    private readonly translocoService: TranslocoService,
    private readonly cnfg: ConfigService,
    private readonly store: Store<AppState>,
    private readonly auth: AuthService,
  ) {}

  ngOnInit() {
    const { id, seqId, sequenceId } = this.actRoute.snapshot.queryParams;
    this.regId = id;
    this.seqId = sequenceId || seqId;

    const params = { UserCode: this.regId, SequenceCode: this.seqId };
    this.isValidDeleteAccountLink$ = this.accountService.getDeleteValidity(params);
  }

  redirectToContactSynlab() {
    window.location.href = this.cnfg._envConfig.BaseProfileUrl;
  }

  delete() {
    const body = { UserCode: this.regId, SequenceCode: this.seqId };

    const url = this.cnfg._envConfig.BaseProfileUrl;
    const loc = window.location;
    this.accountService.confirmDelete(body).subscribe(
      res => {
        const message: string = this.translocoService.translate(
          'confirmDeleteSuccessMessage',
          {},
          deleteScopeKey,
        );
        const title: string = this.translocoService.translate(
          'confirmDeleteSuccessTitle',
          {},
          deleteScopeKey,
        );
        const overrideOptions: any = null;

        this.toastr
          .success(message, title, overrideOptions)
          .onHidden.pipe(take(1))
          .subscribe(d => this.auth.startSignoutMainWindow());
      },
      e => {
        this.toastr.error(
          e.error.ErrorMessage,
          this.translocoService.translate('errorOccuredTitle', {}, generalScopeKey),
        );
      },
    );
  }

  private clearStorageAfterSuccessfulDelete() {
    const sessionLangCode: string = sessionStorage.getItem(LocalStorageKeys.language);
    const localLangCode: string = localStorage.getItem(PATIENT_WEB_LOCALE_STORAGE_KEY);

    sessionStorage.clear();
    localStorage.clear();

    localStorage.setItem(PATIENT_WEB_LOCALE_STORAGE_KEY, localLangCode);
    sessionStorage.setItem(LocalStorageKeys.language, sessionLangCode);
  }
}
